module.exports = __webpack_public_path__ + "img/model_zh_67.2108601b.png";